document.addEventListener('DOMContentLoaded', function () {
  const sublist = document.querySelector('.product__media-sublist');
  const thumbnails = document.querySelectorAll('.product__media-subitem');
  const upThumbnail = document.querySelector('.product__thumbnail.up');
  const downThumbnail = document.querySelector('.product__thumbnail.down');
  const sublistContainer = document.querySelector('.product__media-sublist-container');
  let isScrolling;

  function updateArrowVisibility() {
    if (swiper) {
      const isAtTop = swiper.isBeginning;
      const isAtBottom = swiper.isEnd;

      console.log('Swiper: activeIndex=', swiper.activeIndex, 'totalThumbnails=', thumbnails.length, 'isAtBottom=', isAtBottom);

      upThumbnail.classList.toggle('visible', !isAtTop && upThumbnail);
      downThumbnail.classList.toggle('visible', !isAtBottom && downThumbnail);
    } else {
      const isAtTop = sublistContainer.scrollTop <= 0;
      const isAtBottom = Math.abs(sublistContainer.scrollTop + sublistContainer.clientHeight - sublistContainer.scrollHeight) <= 2;

      console.log('Scroll: scrollTop=', sublistContainer.scrollTop, 'clientHeight=', sublistContainer.clientHeight, 'scrollHeight=', sublistContainer.scrollHeight, 'isAtBottom=', isAtBottom);

      upThumbnail.classList.toggle('visible', !isAtTop && upThumbnail);
      downThumbnail.classList.toggle('visible', !isAtBottom && downThumbnail);
    }

    // Adjust container to include arrows
    if (upThumbnail.classList.contains('visible')) {
      sublistContainer.style.bottom = '16px';
      sublistContainer.style.top = 'unset';
    } else {
      sublistContainer.style.bottom = '0';
    }
    if (downThumbnail.classList.contains('visible')) {
      sublistContainer.style.top = '0';
    } else {
      sublistContainer.style.top = 'unset';
    }
  }

  function showThumbnails() {
    upThumbnail.classList.add('visible');
    downThumbnail.classList.add('visible');
    thumbnails.forEach(thumb => thumb.classList.add('visible'));
    clearTimeout(isScrolling);
  }

  function hideThumbnails() {
    clearTimeout(isScrolling);
    isScrolling = setTimeout(function () {
      thumbnails.forEach(thumb => thumb.classList.remove('visible'));
      updateArrowVisibility();
    }, 300);
  }

  const swiper = sublist?.swiper;
  if (swiper) {
    swiper.on('slideChangeTransitionStart', function () {
      showThumbnails();
      updateArrowVisibility();
    });
    swiper.on('slideChangeTransitionEnd', function () {
      hideThumbnails();
    });
    updateArrowVisibility();
  } else {
    sublistContainer.addEventListener('scroll', function () {
      showThumbnails();
      updateArrowVisibility();
      hideThumbnails();
    });
    updateArrowVisibility();
  }

  // Scroll up all at once
  upThumbnail.addEventListener('click', function () {
    if (swiper) {
      swiper.slideTo(0, 300);
    } else {
      sublistContainer.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  // Scroll down one image at a time
  downThumbnail.addEventListener('click', function () {
    if (swiper) {
      swiper.slideNext(300);
    } else {
      const thumbnailHeight = thumbnails[0]?.offsetHeight || 100;
      sublistContainer.scrollTo({ top: sublistContainer.scrollTop + thumbnailHeight, behavior: 'smooth' });
    }
  });
});